<template>
  <div>
    <!-- adicionar um sepultamento novo -->
    <div v-if="!vefiryObject(propSepultamento) && !show.modal"
         class="itemPadding col-sm-12 m-0 p-0">
      <button class="btn btn-add-sepultamento btn-sm btn-outline-primary btn-block m-0 mb-3"
              type="button"
              @click="show.modal = true">
        <IconSvg class="icon-add icon--sm mr-1"
                 icon="add" />
        Adicionar Local de Sepultamento
      </button>
    </div>
    <!-- mostrando sepultamento atual -->
    <BoxSepultamento v-if="vefiryObject(propSepultamento)"
                     :prop-address-completed="vefiryAddress()"
                     :prop-sepultamento="propSepultamento"
                     :prop-sepultamento-certidao="propSepultamentoCertidao">
      <slot>
        <button type="button"
                class="btn btn-sm btn-danger mr-2"
                @click="removeSepultamento()">
          Excluir
        </button>

        <button class="btn btn-sm btn-primary"
                type="button"
                @click="editSepultamento()">
          Editar
        </button>
      </slot>
    </BoxSepultamento>

    <!-- inicio modal -->
    <sepultamento-modal
      v-if="show.modal"
      :prop-sepultamento="propSepultamento"
      :prop-sepultamento-certidao="propSepultamentoCertidao"
      :prop-edit="show.edit"
      :prop-cartorio="propCartorio"
      @onSaveSepultamento="(sepultamento) => saveSepultamento(sepultamento)"
      @onHideModal="show.modal = false, show.edit = false" />
  </div>
</template>

<script>
  /* components */
  import BoxSepultamento from '@/components/SofiaRei/Obito/Passos/Sessoes/BoxSepultamento.vue'
  import SepultamentoModal from '@/components/SofiaRei/Obito/SegundaVia/FormSepultamentoSV.vue'

  /** constants */
  import { CADASTRAR_LOCAL_SEPULTAMENTO, ADMIN } from "@/constants/permissions"

  /* others */
  import {mapGetters} from "vuex"

  export default {
    name: "Sepultamento",
    components: {
      BoxSepultamento,
      SepultamentoModal
    },
    props: {
      propSepultamento: {
        type: Object,
        default: () => ({})
      },
      propSepultamentoCertidao: {
        type: [Number, Boolean],
        default: () => (false)
      },
      propSepultamentoId: {
        type: [Number, String],
        default: () => null
      },
      propCartorio: {
        type: Object,
        default: () => ({})
      }
    },
    data () {
      return {
        // usado para mostrar e pra informar o pai
        show: {
          modal: false,
          edit: false
        },
        CADASTRAR_LOCAL_SEPULTAMENTO,
        ADMIN
      }
    },
    computed: {
      ...mapGetters({
        user: 'auth/getUser'
      })
    },
    watch: {
      propSepultamento () {
        this.init()
      }
    },
    created () {
      this.init()
    },
    methods: {
      init () {
        // atualizando sepultamento local
        if (this.vefiryObject(this.propSepultamento)) {
          // Object.assign(this.sepultamento, { ...this.propSepultamento })
          // verificando se endereco é completo
          this.vefiryAddress()
        }
      },

      // salvando sepultamento principal
      saveSepultamento (sepultamento) {
        // Verificamos a permissão no método pois nenhuma rota é chamada
        // Se for oficial ou suporte não validamos
        const { groups, flag_oficial } = this.user

        let login = ''

        if (this.user) {
          login = this.user.login.split('_')[0]
        }

        if (groups && groups.length && !flag_oficial) {
          let access = false
          const permissions = [ this.CADASTRAR_LOCAL_SEPULTAMENTO, this.ADMIN]

          groups.forEach(group => {
            const permission = !!group.permissions.find(permission => !!permissions.includes(permission.codename))

            if (permission && group.ativo) access = true
          })

          if (!access && !sepultamento.sepultamento_sugestao_id) {
            return displayMessage('error', 'Acesso negado!', 'Você não tem permissão para realizar essa ação.')
          }
        } else if (login !== 'suporte' && !flag_oficial && !sepultamento.sepultamento_sugestao_id) {
          return displayMessage('error', 'Acesso negado!', 'Você não tem permissão para realizar essa ação.')
        }

        this.changed(sepultamento)
      },

      // excluindo sepultamento
      removeSepultamento () {
        this.sepultamento = null
        this.$emit('onRemoveSepultamento')
      },

      // abrir modal pra editar sepultamento
      editSepultamento () {
        this.show.edit = true
        this.show.modal = true
      },

      // informando componente Pai da mudança
      changed (sepultamento) {
        this.$emit('changed', sepultamento)
      },
      // verificando se endereco eh completo ou nao
      vefiryAddress () {
        if (!this.propSepultamento.endereco) return false

        const { endereco: { logradouro, bairro, numero, cidade, uf, ibge } } = this.propSepultamento

        if ((!!logradouro || !!bairro || !!numero || !!ibge) && (uf && cidade)) {
          return true
        } else {
          return false
        }
      },
      vefiryObject (obj) {
        return !!obj && Object.values(obj).length > 0 || false
      }
    }
  }
</script>


<style scoped lang="scss">
  .Sepultamento {
    &--btn-search {
      position: relative;
      right: 400px;
      top:-10px;
    }
  }

  .btn-add-sepultamento:hover > [class*=icon-add] {
    fill: #fff !important;
  }

  .icon-add {
    fill: #1c7af5 !important;
    width: 16px;
    height: 16px;
    transition: fill 0.2s;
  }

</style >
